export default __webpack_public_path__ + "/assets/abc-home-Lifestyle_03.jpg";